import angular from "angular";
import InstructorCreatePassFailReportCardController from "./create-pass-fail-report-card.controller";
import template from "./create-pass-fail-report-card.html";

function getStudent($stateParams, UsersModel) {
  return UsersModel.getStudentByID($stateParams.studentId).then((response) => {
    return response;
  });
}
getStudent.$inject = ["$stateParams", "UsersModel"];

function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state(
    "drivecoach.instructor.dashboard.createpassfailreportcard",
    {
      url: "/:driveId/:studentId/create-pass-fail-report-card",
      controller: InstructorCreatePassFailReportCardController,
      controllerAs: "vm",
      template: template,
      resolve: {
        student: getStudent,
      },
      data: {
        authorizedRoles: [
          USER_ROLES.admin,
          USER_ROLES.owner,
          USER_ROLES.instructor,
        ],
      },
    },
  );
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("instructor.dashboard.createpassfailreportcard", [])
  .config(config)
  .controller(
    "InstructorCreatePassFailReportCardController",
    InstructorCreatePassFailReportCardController,
  );
